import script from "./carrouselVue.vue?vue&type=script&setup=true&lang=js"
export * from "./carrouselVue.vue?vue&type=script&setup=true&lang=js"

import "./carrouselVue.vue?vue&type=style&index=0&id=22d528a3&scoped=true&lang=scss"

import exportComponent from "../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-22d528a3"]])

export default __exports__